// ============================================================
// Dringlichkeit als Frist — Beschriftung und Rechnung für die Oberfläche.
//
// Spiegelbild von backend/src/storage/frist.ts (dort mit Tests). Ändert sich
// eine Regel, müssen beide Dateien und die Abfrage der Hinweisschicht mit.
// ============================================================
import type { MangelFrist } from "../api/http";

export const FRISTEN: MangelFrist[] = ["sofort", "kurzfristig", "drei_monate", "naechste_hu", "beobachten"];

export const FRIST: Record<MangelFrist, { de: string; kurz: string; en: string; farbe: string; rang: number }> = {
  sofort: { de: "sofort, Gerät sperren", kurz: "sofort", en: "immediately, close equipment", farbe: "#a3201f", rang: 0 },
  kurzfristig: { de: "kurzfristig (4 Wochen)", kurz: "4 Wochen", en: "short-term (4 weeks)", farbe: "#c2591f", rang: 1 },
  drei_monate: { de: "innerhalb 3 Monate", kurz: "3 Monate", en: "within 3 months", farbe: "#bd8524", rang: 2 },
  naechste_hu: { de: "bis zur nächsten Hauptinspektion", kurz: "nächste HU", en: "by next annual inspection", farbe: "#5f8a3c", rang: 3 },
  beobachten: { de: "beobachten", kurz: "beobachten", en: "monitor", farbe: "#8a9aa4", rang: 4 },
};

const AUS_STUFE: Record<string, MangelFrist> = { gefahr: "sofort", hoch: "kurzfristig", mittel: "drei_monate", gering: "naechste_hu" };

/** Frist eines Mangels; ältere Antworten ohne Frist-Feld über die Stufe. */
export function fristVon(m: { frist?: MangelFrist | null; severity?: string | null }): MangelFrist {
  return m.frist ?? AUS_STUFE[m.severity ?? ""] ?? "drei_monate";
}

const iso = (d: Date) => d.toISOString().slice(0, 10);

/** Bis wann zu beheben (YYYY-MM-DD) ab Fundtag; null ohne festes Datum. */
export function zuBehebenBis(frist: MangelFrist, basis: string | null | undefined): string | null {
  const r = /^(\d{4})-(\d{2})-(\d{2})/.exec(basis ?? "");
  if (!r) return null;
  const [j, m, t] = [Number(r[1]), Number(r[2]), Number(r[3])];
  if (frist === "sofort") return iso(new Date(Date.UTC(j, m - 1, t)));
  if (frist === "kurzfristig") return iso(new Date(Date.UTC(j, m - 1, t + 28)));
  if (frist === "drei_monate") {
    const letzter = new Date(Date.UTC(j, m - 1 + 4, 0)).getUTCDate();
    return iso(new Date(Date.UTC(j, m - 1 + 3, Math.min(t, letzter))));
  }
  return null;
}

export function fristUeberschritten(bis: string | null, status: string, heute = new Date()): boolean {
  if (!bis || status === "behoben" || status === "abgelehnt") return false;
  return bis < iso(new Date(Date.UTC(heute.getFullYear(), heute.getMonth(), heute.getDate())));
}

/** „14.12.2026" */
export const deTag = (tag: string) => {
  const [j, m, t] = tag.slice(0, 10).split("-");
  return j && m && t ? `${t}.${m}.${j}` : tag;
};
